import type { ErrorCodeConfig } from "./types"

export const ERROR_CODES = {
  // Offer fetcher errors
  "OFFER-F001": {
    status: 502,
    userMessage: "Unable to load product data. Please try again.",
    severity: "high",
  },
  "OFFER-F002": {
    status: 404,
    userMessage: "Product not found.",
    severity: "low",
  },
  "OFFER-N001": {
    status: 504,
    userMessage: "Product service timed out. Please try again.",
    severity: "high",
  },

  // Cart errors
  "CART-P001": {
    status: 500,
    userMessage: "Unable to process cart operation.",
    severity: "medium",
  },
  "CART-P002": {
    status: 500,
    userMessage: "Unable to process cart event.",
    severity: "medium",
  },
  "CART-V001": {
    status: 400,
    userMessage: "Invalid coupon code.",
    severity: "low",
  },
  "CART-V002": {
    status: 400,
    userMessage: "Invalid gift card.",
    severity: "low",
  },

  // Order errors
  "ORDER-P001": {
    status: 500,
    userMessage: "Unable to retrieve order.",
    severity: "medium",
  },
  "ORDER-P002": {
    status: 500,
    userMessage: "Unable to process order.",
    severity: "medium",
  },
  "ORDER-P003": {
    status: 500,
    userMessage: "Unable to retrieve order details.",
    severity: "medium",
  },
  "ORDER-A001": {
    status: 401,
    userMessage: "Authentication required to view orders.",
    severity: "low",
  },

  // Payment errors (PayPal only — Stripe uses its own system)
  "PAY-P001": {
    status: 500,
    userMessage: "Unable to create payment. Please try again.",
    severity: "high",
  },
  "PAY-P002": {
    status: 500,
    userMessage: "Unable to capture payment. Please try again.",
    severity: "high",
  },
  "PAY-P003": {
    status: 500,
    userMessage: "Unable to update payment total. Please try again.",
    severity: "high",
  },

  // Shipping & Tax
  "SHIP-P001": {
    status: 500,
    userMessage: "Unable to calculate shipping.",
    severity: "medium",
  },
  "TAX-P001": {
    status: 500,
    userMessage: "Unable to calculate tax.",
    severity: "medium",
  },

  // Store page-level errors
  "STORE-F001": {
    status: 500,
    userMessage: "Unable to load page data.",
    severity: "high",
  },
  "STORE-X001": {
    status: 500,
    userMessage: "An unexpected error occurred.",
    severity: "medium",
  },

  // System / infrastructure
  "SYS-P001": {
    status: 500,
    userMessage: "Unable to process request.",
    severity: "medium",
  },
  "SYS-N001": {
    status: 503,
    userMessage: "Service temporarily unavailable.",
    severity: "high",
  },
  "SYS-X001": {
    status: 500,
    userMessage: "An unexpected error occurred.",
    severity: "medium",
  },

  // API surface
  "API-N001": {
    status: 404,
    userMessage: "API endpoint not found.",
    severity: "low",
  },

  // WebMCP — agent-driven storefront tools
  "WEBMCP-P001": {
    status: 500,
    userMessage: "Unable to load product.",
    severity: "low",
  },
  "WEBMCP-P002": {
    status: 500,
    userMessage: "Unable to load channel.",
    severity: "low",
  },
  "WEBMCP-P003": {
    status: 500,
    userMessage: "Unable to search products.",
    severity: "low",
  },
} as const satisfies Record<string, ErrorCodeConfig>

export type ErrorCode = keyof typeof ERROR_CODES
